export default {
    TYPE: "Тип",
    ATTRIBUTE_FOR_BUILDING_NAME_AND_RUN_METHODS: "Атрибут для формирования имени узла"
};
